import React, { useState, useEffect, useRef } from "react";
import "./CategoryMenu.css";

const MAX_SUBCATEGORIES = 5;

const CategoryMenu = ({ categories, onPickCategory }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [expandedSubcategories, setExpandedSubcategories] = useState({});
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
  if (!menuOpen) {
    setHoveredCategory(null);
  }
}, [menuOpen]);

  const toggleExpand = (subCategoryId) => {
    setExpandedSubcategories((prev) => ({
      ...prev,
      [subCategoryId]: !prev[subCategoryId],
    }));
  };

  return (
    <div className="category-menu-wrapper" ref={menuRef}>
      <button className="categories-button" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? "✕ Κλείσιμο κατηγοριών" : "Όλες οι κατηγορίες"}
      </button>

      {menuOpen && (
        <div className="full-screen-menu">
          {/* Левая колонка — Категории */}
          <div className="category-column">
            {categories
              .filter((category) => !category.parent)
              .map((category) => (
                <div
                  key={category.id}
                  className={`category-name ${
                    hoveredCategory?.id === category.id ? "active" : ""
                  }`}
                  onMouseEnter={() => setHoveredCategory(category)}                                      
                >
                  {category.name}
                </div>
              ))}
          </div>

          {/* Правая часть — Подкатегории */}
          <div className="subcategory-panel">
            {hoveredCategory && (
              <>
                <button
                  type="button"
                  className="top-category-title"
                  onClick={() => { onPickCategory?.(hoveredCategory.id); setMenuOpen(false); }}
                >
                  {hoveredCategory.name}
                </button>
                <div className="subcategory-groups">
                  {hoveredCategory.subcategories.map((subCategory) => {
                    

                    return (
                      <div key={subCategory.id} className="subcategory-block">
                        <button
                          type="button"
                          className="subcategory-title"
                          onClick={() => {
                            onPickCategory?.(subCategory.id);
                            setMenuOpen(false);
                          }}
                        >
                          {subCategory.name}
                        </button>

                        <ul className="sub-subcategory-list">
                          {subCategory.subcategories &&
                            subCategory.subcategories
                              .slice(
                                0,
                                expandedSubcategories[subCategory.id]
                                  ? subCategory.subcategories.length
                                  : MAX_SUBCATEGORIES
                              )
                              .map((subSubCategory) => (
                                <li key={subSubCategory.id}>
                                  <button
                                    type="button"
                                    className="subcategory-link"
                                    onClick={() => {
                                      onPickCategory?.(subSubCategory.id);
                                      setMenuOpen(false);
                                    }}
                                  >
                                    {subSubCategory.name}
                                  </button>
                                </li>
                              ))}

                          {subCategory.subcategories &&
                            subCategory.subcategories.length > MAX_SUBCATEGORIES && (
                              <li
                                className="more-subcategories"
                                onClick={() => toggleExpand(subCategory.id)}
                              >
                                (
                                {expandedSubcategories[subCategory.id]
                                  ? "Λιγότερα"
                                  : `Άλλα ${
                                      subCategory.subcategories.length - MAX_SUBCATEGORIES
                                    }`}
                                )
                              </li>
                            )}
                        </ul>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryMenu;
